import { render, staticRenderFns } from "./decoration1.vue?vue&type=template&id=4d790500&scoped=true"
import script from "./decoration1.vue?vue&type=script&lang=js"
export * from "./decoration1.vue?vue&type=script&lang=js"
import style0 from "./decoration1.vue?vue&type=style&index=0&id=4d790500&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d790500",
  null
  
)

export default component.exports